export default __webpack_public_path__ + "static/media/EM0333.34I-41692_-24996_0.97a5c28e.jpg";